import React, { useEffect, useState } from 'react';

declare global {
  interface Window {
    JitsiMeetExternalAPI: any;
  }
}

interface JitsiMeetingsProps {
  onClose?: () => void;
}

export function JitsiMeetings({ onClose }: JitsiMeetingsProps) {
  const [api, setApi] = useState<any>(null);

  useEffect(() => {
    if (window.JitsiMeetExternalAPI) {
      const meetingContainer = document.querySelector('#meeting-container');
      if (meetingContainer) {
        const vh = window.innerHeight * 0.92; // 92% of viewport height to ensure buttons are visible
        meetingContainer.setAttribute('style', `height: ${vh}px;`);
      }
      
      // Ensure container exists before initializing
      if (!meetingContainer) {
        console.error('Meeting container not found');
        return;
      }

      const jitsiApi = new window.JitsiMeetExternalAPI("8x8.vc", {
        roomName: "vpaas-magic-cookie-80696f7ed4fa47b2a7692900425ac728/Techton",
        parentNode: meetingContainer,
        width: '100%',
        height: '100%',
        configOverwrite: {
          startWithAudioMuted: true,
          startWithVideoMuted: true,
          prejoinPageEnabled: false,
          disableDeepLinking: true,
          defaultLayout: 'vertical',
          buttonsAlignment: 'center',
          filmStripOnly: false,
          verticalFilmstrip: true,
          filmstripMaxHeight: '30%',
        },
        interfaceConfigOverwrite: {
          SHOW_JITSI_WATERMARK: false,
          SHOW_WATERMARK_FOR_GUESTS: false,
          DEFAULT_BACKGROUND: '#0f172a',
          TOOLBAR_BUTTONS: [
            'camera',
            'chat',
            'closedcaptions',
            'desktop',
            'download',
            'embedmeeting',
            'etherpad',
            'feedback',
            'filmstrip',
            'fullscreen',
            'hangup',
            'help',
            'highlight',
            'invite',
            'linktosalesforce',
            'livestreaming',
            'microphone',
            'noisesuppression',
            'participants-pane',
            'profile',
            'raisehand',
            'recording',
            'security',
            'select-background',
            'settings',
            'shareaudio',
            'sharedvideo',
            'shortcuts',
            'stats',
            'tileview',
            'toggle-camera',
            'videoquality',
            '__end'
          ]
        }
      });

      // Handle hangup event
      jitsiApi.addListener('videoConferenceLeft', () => {
        if (onClose) {
          onClose();
        }
      });

      // Add event listener for resize to adjust container height
      const handleResize = () => {
        const meetingContainer = document.querySelector('#meeting-container');
        if (meetingContainer) {
          const vh = window.innerHeight * 0.92;
          meetingContainer.setAttribute('style', `height: ${vh}px;`);
        }
      };

      window.addEventListener('resize', handleResize);

      setApi(jitsiApi);

      return () => {
        window.removeEventListener('resize', handleResize);
        if (jitsiApi) {
          jitsiApi.dispose();
        }
      };
    }
  }, [onClose]);

  return (
    <div className="flex flex-col items-center justify-center p-4 bg-slate-900 min-h-screen">
      <div id="meeting-container" className="w-full rounded-lg overflow-hidden"></div>
    </div>
  );
}